import React from "react";
import { useQuestionPreview } from "../../queries";
import type { PreviewAttrs } from "../../api";
import { ResolvedQuestionPreview } from "./ResolvedComponents";
import { PatientPreviewShell } from "./PatientPreviewShell";
import { previewStyles as styles } from "./previewStyles";

const QuestionPreviewWrapper: React.VFC<{
  id: number;
  isExpanded: boolean;
  onToggleExpand: () => void;
  attrs: PreviewAttrs;
  onAttrsChange: (attrs: PreviewAttrs) => void;
}> = ({ id, isExpanded, onToggleExpand, attrs, onAttrsChange }) => {
  const { data: previewData, isLoading, error } = useQuestionPreview(id, attrs);

  return (
    <PatientPreviewShell
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      isLoading={isLoading}
      error={error}
      attrs={attrs}
      onApplyAttrs={onAttrsChange}
    >
      {previewData?.question && (
        <div className={styles.preview}>
          <ResolvedQuestionPreview question={previewData.question} />
        </div>
      )}
    </PatientPreviewShell>
  );
};

export default QuestionPreviewWrapper;
